import { useFormState, useWatch } from 'react-hook-form';
import FilterIcon, { FilterIconProps } from './FilterIcon';

export interface FilterCounterOverride {
  name: string;
  getCount: (value: unknown) => number;
}

interface FilterIconWithCounterFromFormProps
  extends Omit<FilterIconProps, 'filterCounter'> {
  /**
   * Fields whose applied state cannot be derived from dirtiness — e.g. a field
   * with a non-neutral default value, which narrows the list before the user
   * touches it. Each override replaces the dirty check for its own field.
   */
  counterOverrides?: FilterCounterOverride[];
}

const FilterIconWithCounterFromForm = ({
  counterOverrides = [],
  ...props
}: FilterIconWithCounterFromFormProps) => {
  const { dirtyFields } = useFormState();
  const overriddenNames = counterOverrides.map(({ name }) => name);
  const overriddenValues = useWatch({
    name: overriddenNames,
    disabled: !overriddenNames.length,
  });

  const dirtyCount = Object.keys(dirtyFields).filter(
    (field) => !overriddenNames.includes(field),
  ).length;

  const overriddenCount = counterOverrides.reduce(
    (total, { getCount }, index) => total + getCount(overriddenValues?.[index]),
    0,
  );

  return <FilterIcon filterCounter={dirtyCount + overriddenCount} {...props} />;
};

export default FilterIconWithCounterFromForm;
